import { render } from "./PopupAppointmentPatient.vue?vue&type=template&id=8343b962&scoped=true&ts=true"
import script from "./PopupAppointmentPatient.vue?vue&type=script&lang=ts"
export * from "./PopupAppointmentPatient.vue?vue&type=script&lang=ts"

import "./PopupAppointmentPatient.vue?vue&type=style&index=0&id=8343b962&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8343b962"]])

export default __exports__